var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('head',[_c('title',[_vm._v("Ruby技術者認定試験一問一答")])]),_c('Header'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }